export type ISize = 'small' | 'middle' | 'large'
export type ISizeConfig = {
  [key in ISize]: {
    fontSize: string
    padding: string
    borderRadius: string
    height: string
    lineHeight: string
  }
}

export const sizeConfig: ISizeConfig = {
  small: {
    fontSize: '12px',
    padding: '0px 6px',
    borderRadius: '6px',
    height: '22px',
    lineHeight: '22px',
  },
  middle: {
    fontSize: '14px',
    padding: '0px 8px',
    borderRadius: '8px',
    height: '27px',
    lineHeight: '27px',
  },
  large: {
    fontSize: '16px',
    padding: '0px 10px',
    borderRadius: '8px',
    height: '32px',
    lineHeight: '32px',
  },
}
